import styles from './NavBar2.module.css';
import { NavLink } from 'react-router-dom';
import {navItems} from '../../data';
import { collections, documents } from '../../firebase/firestoreNameSpaces';
import {string_to_slug as slug} from "../../store/utility";
import {withRouter} from "react-router-dom";
import React,{useState} from "react"
import Spinner from '../Spinner/Spinner';
import SearchBar from '../UI/SearchBar/SearchBar';
const Navbar = (props) => {
    const[loading,setLoading] = useState(false)
    const clickShop = async()=>{
       try{
        setLoading(true)
        let db =  require("../../firebase/index").firebase.firestore();
        let data = (await db.collection(collections.K5METADATA).doc(documents.SHOP).get()).data();
        let subcategories = data.subcategories;
        let firstsubid = Object.keys(subcategories)[0];
        let url = `/shop/${slug(subcategories[firstsubid])}/pt1/${data.id}/${firstsubid}`
        setLoading(false)
        props.history.push(url)
       }catch(error){
        setLoading(false)
       }
    }
    //creates a list of links
    const items = (
        navItems.map((item, index) => {
            return (
                <li className="nav-item" key={item.name}>
                    {
                        item.shop?
                        <a className={"nav-link active "+ styles.navItemsLink} 
                            id="shop"
                            style={{cursor:"pointer"}}
                            onClick={clickShop}
                        >{item.name}</a>
                        :
                    <NavLink to={item.url} 
                        activeClassName={styles.active}
                        exact className={"nav-link active "+ styles.navItemsLink}>{item.name}
                    </NavLink>
                    }
                   
                </li>
            )
        })
    ) 

    return (
        <>
        {loading&&
        
             <Spinner/>
       
       
        }
       
        <nav className={"navbar bg-light navbar-light w-100 " + styles.nav2}
            style={{ padding: "0px" }}>

            <div style={{
                "listStyle": "none",
                width: "100%", display: "flex",
                "justifyContent": "flex-start", "alignItems": "center"
            }}>

                <span onClick={() => props.navHandler()}
                    style={{ padding: "10px" }}>

                    <i className="fa fa-navicon"
                        style={{ fontSize: "1.5rem", cursor: "pointer" }}></i>
                </span>


                <div style={{ marginLeft: "auto" }} className={styles.navItems} >
                    {items}
                </div>

            </div> 
        </nav>
       
        {document.body.clientWidth<768?<SearchBar />:null}
        
      
        </>
    )

}

export default withRouter(Navbar);